/**
 * The files a passing server build checked that this tab does not hold.
 *
 * Chef runs the writes and the build, and streams each write here as a `serverWrite` annotation.
 * A write that never arrives left the tab without a file the build had passed with: Ledgerly v3
 * (1 Oct 2026) saved a version whose page imported a `ProductPreview.tsx` the tab never received,
 * and crashed on load. Every passing build now lists its source files; any listed here as missing
 * is reported as drift, so the turn's files are fetched from the server before the snapshot.
 */
export function missingServerBuiltFiles(
  paths: unknown,
  held: Readonly<Record<string, unknown>>,
): string[] {
  if (!Array.isArray(paths)) return [];
  return paths.filter(
    (path): path is string =>
      typeof path === 'string' && path.startsWith('src/') && held[path] === undefined,
  );
}
